// extracted by mini-css-extract-plugin
export default {"swiper":"InformationSwiper_swiper__92CDI"};